import React, { PureComponent, ReactNode } from 'react'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { connectRedux } from '../../../helpers/connectRedux'
import { IStoreState } from '../../../store/states'
import { Page } from '../../../components'
import LanguageSelector from '../../../containers/LanguageSelector'
import { SignUpStep2Form, SIGN_UP_STEP_TITLES } from '../../../containers/SignUpForms'
import { images } from '../../../images'
import { urls } from '../../../routing'
import { LiteralsService } from '../../../services'
import StyledArticle from '../styles'
import { appsLogosSelected, appsStyleSelected } from '../../../helpers/app'

// The fields and their rules live in SignUpStep2Form, shared with the prompt shown to guests.
interface IProps extends RouteComponentProps {
  language: string
}

class SignUpStep2 extends PureComponent<IProps> {
  public render(): ReactNode {
    return (
      <Page className={ appsStyleSelected?.style }>
        <StyledArticle>
          <div className="language-selector">
            <LanguageSelector />
          </div>
          <form onSubmit={ e => e.preventDefault() }>
            <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
            <header>
              <img  className={ appsLogosSelected?.classRounded }
                    src={ appsLogosSelected?.logoRounded }
                    alt={ appsLogosSelected?.alt } />
              <h2>{ LiteralsService.get(SIGN_UP_STEP_TITLES[1], true) }</h2>
            </header>
            <SignUpStep2Form onContinue={ this.goToStep3 } />
          </form>
        </StyledArticle>
      </Page>
    )
  }

  private goToStep3 = (): void => {
    this.props.history.push(urls.signUpStep3)
  }

  private handleGoBack = (): void => {
    history.back()
  }
}

// Redraws the literals when the language selector changes the language.
const mapStateToProps = ({ configuration }: IStoreState) => ({
  language: configuration.language
})

export default withRouter(connectRedux(mapStateToProps, SignUpStep2))
